module.exports = __webpack_public_path__ + "static/media/dmg.241d30c7.png";